const LocationSection = () => {
  return (
    <section className="bg-cream py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-10 items-center">
          <div className="col-span-5 pl-8">
            <div className="inline-block px-4 py-2 bg-sage/10 rounded-full mb-5">
              <span className="text-xs uppercase tracking-wider text-sage font-sans font-medium">
                Find Us
              </span>
            </div>

            <h2 className="text-5xl font-bold text-charcoal font-serif mb-4 leading-tight">
              Located in Otley
            </h2>

            <p className="text-lg text-gray-700 font-sans leading-relaxed mb-8">
              Proudly serving the <em className="font-medium">local community</em>
            </p>

            <div className="space-y-2 mb-10 text-base text-gray-700 font-sans font-medium">
              <p>Riverdale Hair Studio</p>
              <p>Market Place</p>
              <p>Otley, West Yorkshire</p>
              <p>LS21 3AQ</p>
            </div>

            <a
              href="https://www.google.com/maps/place/Otley,+West+Yorkshire"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3 bg-sage text-white font-sans text-base font-medium rounded-full hover:bg-sage-dark transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-pin-line"></i>
              Get Directions
            </a>
          </div>

          <div className="col-span-7">
            <div className="rounded-3xl overflow-hidden border border-gray-200 shadow-lg h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2359.9849204756!2d-1.6938!3d53.9055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48795e1c5c5c5c5c%3A0x5c5c5c5c5c5c5c5c!2sOtley%2C%20West%20Yorkshire!5e0!3m2!1sen!2suk!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Riverdale Hair Studio Location Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;